export default __webpack_public_path__ + "static/media/dating.d380780e.png";